import React, { Fragment } from 'react';
import { CachedImage, Text } from 'core';
import { TextMsg } from './text';
import { imageProcessor } from 'utils';
import { IMAGE_SIZE } from 'constants';

export const PhotoMsg = ({ current_msg }) => {
  const { width, height } = current_msg.data;
  const size = imageProcessor.getDimensions(width / height, IMAGE_SIZE.MEDIUM);
  return (
    <Fragment>
      <CachedImage size={size} color={`#${current_msg.data.color}`} is_large upload={current_msg.data} />
      {current_msg.text ? <TextMsg current_msg={current_msg} /> : null}
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/middle/chat/msgs/photo.js